import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import drawing from './reducers/drawing'

import masterDataReducer from './reducers/masterData'
import customerReducer from './reducers/customerData'
import itemReducer from './reducers/item'
import reportReducer from './reducers/report'

import sellOrderReducer from './reducers/sellOrder'
import masterCoatungReducer from './reducers/masterDatas/coating'
import masterFinEdgeReducer from './reducers/masterDatas/finEdge'
import masterFinMaterialReducer from './reducers/masterDatas/finMaterial'
import masterFinSurfaceReducer from './reducers/masterDatas/finSurface'
import masterTubeSizeReducer from './reducers/masterDatas/tubeSize'
import masterInsideShapeReducer from './reducers/masterDatas/insideShape'
import masterTubeMaterialReducer from './reducers/masterDatas/tubeMaterial'
import masterPlateMaterialReducer from './reducers/masterDatas/plateMaterial'
import masterTubePatternReducer from './reducers/masterDatas/tubePattern'
import masterTuneSizeAndPatternReducer from './reducers/masterDatas/tubeSizeAndPattern'
import masterProductGroupReducer from './reducers/masterDatas/productGroup'
import masterPaintLocationReducer from './reducers/masterDatas/paintLocation'
import settingReducer from './reducers/setting'
import masterCoilTypeReducer from './reducers/masterDatas/coiltype'

import systemReducer from './reducers/manage/system'
import groupReducer from './reducers/manage/group'
import userReducer from './reducers/user'
import oneDriveReducer from './reducers/oneDrive'

export default combineReducers({
    form: formReducer,
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: userReducer.users,
    user: userReducer.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API

    isLoading: reducerCallAPI.isLoading,

    drawing: drawing.drawing,
    drawings: drawing.drawings,
    masterData: masterDataReducer.masterData,
    masterCoating: masterCoatungReducer.masterCoating,
    masterCoatings: masterCoatungReducer.masterCoatings,
    masterFinEdge: masterFinEdgeReducer.masterFinEdge,
    masterFinEdges: masterFinEdgeReducer.masterFinEdges,
    masterFinMaterial: masterFinMaterialReducer.masterFinMaterial,
    masterFinMaterials: masterFinMaterialReducer.masterFinMaterials,
    masterFinSurface: masterFinSurfaceReducer.masterFinSurface,
    masterFinSurfaces: masterFinSurfaceReducer.masterFinSurfaces,
    masterTubeSize: masterTubeSizeReducer.masterTubeSize,
    masterTubeSizes: masterTubeSizeReducer.masterTubeSizes,
    masterInsideShape: masterInsideShapeReducer.masterInsideShape,
    masterInsideShapes: masterInsideShapeReducer.masterInsideShapes,
    masterTubeMaterial: masterTubeMaterialReducer.masterTubeMaterial,
    masterTubeMaterials: masterTubeMaterialReducer.masterTubeMaterials,
    masterPlateMaterial: masterPlateMaterialReducer.masterPlateMaterial,
    masterPlateMaterials: masterPlateMaterialReducer.masterPlateMaterials,
    masterTubePattern: masterTubePatternReducer.masterTubePattern,
    masterTubePatterns: masterTubePatternReducer.masterTubePatterns,
    masterTubeSizeAndPattern: masterTuneSizeAndPatternReducer.masterTubeSizeAndPattern,
    masterTubeSizeAndPatterns: masterTuneSizeAndPatternReducer.masterTubeSizeAndPatterns,
    masterProductGroup: masterProductGroupReducer.masterProductGroup,
    masterProductGroups: masterProductGroupReducer.masterProductGroups,
    masterPaintLocation: masterPaintLocationReducer.masterPaintLocation,
    masterPaintLocations: masterPaintLocationReducer.masterPaintLocations,

    masterCoilType: masterCoilTypeReducer.masterCoilType,
    masterCoilTypes: masterCoilTypeReducer.masterCoilTypes,

    manageSystem: systemReducer.manageSystem,
    manageSystems: systemReducer.manageSystems,
    manageGroup: groupReducer.manageGroup,
    manageGroups: groupReducer.manageGroups,

    item: itemReducer.item,
    report: reportReducer.report,
    reportFollow: reportReducer.reportFollow,
    reportSummary: reportReducer.reportSummary,
    reportViewDrawing: reportReducer.reportViewDrawing,

    customerData: customerReducer.customerData,
    sellOrder: sellOrderReducer.sellOrder,
    sellOrders: sellOrderReducer.sellOrders,
    reqTube: sellOrderReducer.reqTube,
    reqTubes: sellOrderReducer.reqTubes,
    reqAcc: sellOrderReducer.reqAcc,
    reqAccs: sellOrderReducer.reqAccs,

    reStatusToSubmit: sellOrderReducer.reStatusToSubmit,
    setting: settingReducer.setting,


    reqTubeAllTube: sellOrderReducer.reqTubeAllTube,
    reqAccAllTube: sellOrderReducer.reqAccAllTube,
    oneDriveItems: oneDriveReducer.items,




})



// WEBPACK FOOTER //
// ./src/app/redux/reducers.js